import { render, staticRenderFns } from "./Footer2.vue?vue&type=template&id=5b30b6df&scoped=true"
import script from "./Footer2.vue?vue&type=script&lang=js"
export * from "./Footer2.vue?vue&type=script&lang=js"
import style0 from "./Footer2.vue?vue&type=style&index=0&id=5b30b6df&prod&lang=css"
import style1 from "./Footer2.vue?vue&type=style&index=1&id=5b30b6df&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b30b6df",
  null
  
)

export default component.exports